export const role = [
  "admin",
  "branchAdmin",
  "lawyer",
  "staff",
  "client",
  "agent",
];

export const fileStatus = [
  "fileCreated", // File Created
  "generateESpaForDeveloper", // Generate e-SPA for Developer
  "draftingSpa", // Drafting/Vetting of SPA
  "uploadTitleSearch", // Upload Title Search
  "executionOfSpaVendorPurchaser", // Execution of SPA - Vendor/Purchaser
  "dulyStampedSpa", // Duly Stamped of SPA
  "uploadDulyExecutedSpa", // Upload Duly Executed SPA
  "letterOfInstructionFromFinancialInstitution", // Letter of Instruction from Financial Institution
  "dulyStampedLetterOffer", // Duly Stamped of Letter Offer
  "requestConfirmationLetterFromDeveloper", // Request Confirmation Letter from Developer
  "requestRedemptionStatement", // Request Redemption Statement from Financial Institution cum Undertaking Letter
  "receivedRedemptionStatement", // Received Redemption Statement from Financial Institution cum Undertaking Letter
  "applicationConsentToTransfer", // Application Consent to Transfer
  "applicationConsentToCharge", // Application Consent to Charge
  "adoAtLandOffice", // ADO - at land office
  "eFilingSystem", // E-filing System
  "applicationLetterAdministrationFromHighCourt", // Application of Letter Administration from the High Court
  "applicationOrderForSaleFromHighCourt", // Application of Order for Sale from the High Court
  "submissionOfRpgtForm", // Submission of RPGT Form
  "replyLetterConfirmationToLoanSolicitor", // Reply Letter of Confirmation cum Undertaking to the Loan Solicitor
  "submissionLoanDocumentsToFinancialInstitution", // Submission of Loan Documents to the Financial Institution
  "receivedDulyExecutedLoanDocuments", // Received Duly Executed Loan Documents from Financial Institution
  "enterCaviat", // Entry Caveat
  "firstDisbursement", // Notification of First Disbursement
  "requestOriginalTitleDeed", // Request Original Title Deed/Deed of Assignment from Financial Institution (Vendor)
  "obtainingOriginalTitleAndDischargeOfCharge", // Obtaining Original Title and Discharge of Charge Document (Vendor)
  "obtainingLetterConfirmationFromLoanSolicitor", // Obtaining Letter Confirmation cum Undertaking from Loan Solicitor (Original Title)
  "stamped16N", // Stamped 16N/Deed of Receipt and Reassignment
  "stamped16A", // Stamped 16A
  "stamped14A", // Stamped 14A
  "forwardOriginalTitleDeedToLoanSolicitor", // Forward Original Title Deed/14A/16N to Loan Solicitor for Registration at the Land Office
  "forwardOriginalTitleDeedToFinancier", // Forward Original Title Deed to Financier
  "registrationMemorandumOfTransferF14A", // Registration Memorandum of Transfer (F14A)
  "registrationMemorandumOfTransferF16A", // Registration Memorandum of Transfer (F16A)
  "withdrawalCaviat", // Withdrawal Caveat
  "servedNoticeOfAssignment", // Served Notice of Assignment (NOA) to the Developer
  "finalDisbursement", // Notification of Final Disbursement
  "acknowledgementOfUtilitiesBill", // Acknowledgement Duly Paid of Utilities Bills
  "vendorHandoverKeys", // Vendor Handover Bundle of Keys
  "vacantPossession", // Vacant Possession
  "acknowledgementChangeOfNameUtilities", // Acknowledgement Change of Name of Utilities Bills
  "dulyRegisteredTitle", // Duly Registered Title
  "agencyFee", // Agency Fee
  "referralFee", // Referral Fee
  "paExecution", // PA Execution
  "dischargeOfCharge", // Discharge of Charge
  "applyForValuationReportFromJPPH", // Apply for Valuation Report from JPPH
  "receivedValuationReportFromJPPH", // Received Valuation Report from JPPH
  "submitHousingLoanApplicationToLPPSA", // Submit a Housing Loan Application to LPPSA
  "loanApprovedByLPPSA", // Loan approved by LPPSA
  "receivedApplicationConsentToTransfer", // Received Application Consent to Transfer
  "receivedApplicationConsentToCharge", // Received Application Consent to Charge
  "submissionAdviceToRelease1", // Submission Advice to Release 1 to Financial Institution
  "submissionAdviceToRelease2", // Submission Advice to Release 2 to Financial Institution
  "pendingDulyExecutedLoanDocuments", // Pending Duly Executed Loan Documents from Financial Institution
  "registrationOfForm16F", // Registration of Form 16F
  "forwardForm16FToHighCourt", // Forward Form 16F to the High Court
  "revocationOfDocuments", // Revocation of Documents at the High Court
  "forwardNotificationOfDisbursement", // Forward Notification of Disbursement to SPA Solicitor
  "forwardActingFirstLetterToSpaSolicitor", // Forward Acting First Letter to SPA Solicitor
  "forwardActingFinalLetterToLoanSolicitor", // Forward Acting Final Letter to Loan Solicitor
  "receivedFinanciersLetter", // Received Financier's Letter of Undertaking from Loan Solicitor
  "receivedOrderForSaleFromHighCourt", // Received Order for Sale from the High Court
  "receivedBorangEFTFromPejabatPesaka", // Received Borang E/Borang F/Borang T from Pejabat Pesaka
  "applicationOfBorangEFTFromPejabatPesaka", // Application of Borang E/Borang F/Borang T from Pejabat Pesaka
  "receivedLetterAdministrationFromHighCourt", // Received Letter Administration from the High Court
  "cancel", // Cancel
  "others", // Others
  "completed", // Completed
  // "archived", // archived
];

export const fileType = [
  "litigation", // Litigation
  "refinance", // Refinance
  "auction", // Auction
  "spaOnly", // Sale and Purchase Agreement only
  "spaLppsa", // SPA with LPPSA loan
  "spaWithBank", // SPA with Bank Loan
  "lppsaOnly", // LPPSA loan documentation only
  "pibbOnly", // PIBB loan documentation only
  "bimbOnly", // BIMB loan documentation only
  "cimbOnly", // CIMB loan documentation only
  "miscTenancy", // Miscellaneous - Tenancy Agreement
  "miscDischargeCharge", // Miscellaneous - Discharge of Charge
  "miscMot", // Miscellaneous - MOT (Memorandum of Transfer)
  "miscHibah", // Miscellaneous - Hibah (Islamic Gift)
  "miscPerfection", // Miscellaneous - Perfection
  "miscOthers", // Miscellaneous - Other cases
  "contractAgreement", // Contract Agreement
  "others", // Other general cases
];

export const fileBillType = [
  "16a",
  "14a",
  "16n",
  "spa",
  "loan",
  "devMot",
  "devMoc",
  "ta",
  "auc",
  "ca",
  "poc",
  "pot",
  "others",
  "miscellaneous",
];

export const fileClientType = [
  "cashVendor", // Cash Vendor only
  "cashPurchaser", // Cash Purchaser only
  "cashVendorPurchaser", // Cash Vendor and Purchaser
  "bankVendor", // Bank Vendor only
  "bankPurchaser", // Bank Purchaser only
  "bankVendorPurchaser", // Bank Vendor and Purchaser
  "vendorPurchaserLoan", // Vendor, Purchaser and Loan
  "purchaserLoan", // Purchaser and Loan
  "loanOnly", // Loan only
  "tenancy", // Tenancy
  "perfectionCharge", // Perfection of Charge
  "perfectionTransfer", // Perfection of Transfer
  "others", // Others
];

export const fileClientCategory = [
  "vendor", // Vendor only
  "purchaser", // Purchaser only
  "both", // Vendor and Purchaser
  "developer", // Developer only
  "corporate", // Corporate only
  "contractor", // Contractor only
  "others", // Others
];

export const leaveType = [
  "annual", // Annual leave
  "medical", // Medical leave
  "hospitalization", // Hospitalization leave
  "maternity", // Maternity leave
  "unpaid", // Unpaid leave
  "compassionate", // Compassionate leave
  "marriage", // Marriage leave
];

export const leaveStatus = [
  "pending", // Pending
  "approved", // Approved
  "rejected", // Rejected
];

export const claimType = [
  "normalOT", // Normal OT
  "weekendOT", // Weekend OT
  "attendClient", // Attend Client
  "medical", // Medical leave
  "travel", // Travel leave
  "commission", // Commission leave
];

export const claimStatus = [
  "pending", // Pending
  "approved", // Approved
  "rejected", // Rejected
];

export const departmentType = [
  "conveyancing", // Conveyancing
  "litigation", // Litigation
];

export const citizenshipType = [
  "malaysian", // Malaysian
  "non-malaysian", // Non-Malaysian
];

export const userTaxCategory = [
  "single", // Single
  "spouseNotWorkingNoChild", // Spouse not working, No child
  "spouseNotWorking1Child", // Spouse not working, 1 child
  "spouseNotWorking2Children", // Spouse not working, 2 children
  "spouseNotWorking3Children", // Spouse not working, 3 children
  "spouseNotWorking4Children", // Spouse not working, 4 children
  "spouseNotWorking5Children", // Spouse not working, 5 children
  "spouseNotWorking6Children", // Spouse not working, 6 children
  "spouseNotWorking7Children", // Spouse not working, 7 children
  "spouseNotWorking8Children", // Spouse not working, 8 children
  "spouseNotWorking9Children", // Spouse not working, 9 children
  "spouseNotWorking10Children", // Spouse not working, 10 children
  "spouseWorkingNoChild", // Spouse working, No child
  "spouseWorking1Child", // Spouse working, 1 child
  "spouseWorking2Children", // Spouse working, 2 children
  "spouseWorking3Children", // Spouse working, 3 children
  "spouseWorking4Children", // Spouse working, 4 children
  "spouseWorking5Children", // Spouse working, 5 children
  "spouseWorking6Children", // Spouse working, 6 children
  "spouseWorking7Children", // Spouse working, 7 children
  "spouseWorking8Children", // Spouse working, 8 children
  "spouseWorking9Children", // Spouse working, 9 children
  "spouseWorking10Children", // Spouse working, 10 children
];

// Define the labels for each type
const roleLabelsArray = [
  "Branch Admin",
  "Admin",
  "Lawyer",
  "Staff",
  "Client",
  "Agent",
];

const fileStatusLabelsArray = [
  "File Created",
  "Generate e-SPA for Developer",
  "Drafting/Vetting of SPA",
  "Upload Title Search",
  "Execution of SPA - Vendor/Purchaser",
  "Duly Stamped of SPA",
  "Upload Duly Executed SPA",
  "Letter of Instruction from Financial Institution",
  "Duly Stamped of Letter Offer",
  "Request Confirmation Letter from Developer",
  "Request Redemption Statement from Financial Institution cum Undertaking Letter",
  "Received Redemption Statement from Financial Institution cum Undertaking Letter",
  "Application Consent to Transfer",
  "Application Consent to Charge",
  "ADO - at land office",
  "E-filing System",
  "Application of Letter Administration from the High Court​",
  "Application of Order for Sale from the High Court​",
  "Submission of RPGT Form",
  "Reply Letter of Confirmation cum Undertaking to the Loan Solicitor",
  "Submission of Loan Documents to the Financial Institution",
  "Received Duly Executed Loan Documents from Financial Institution",
  "Entry Caveat",
  "Notification of First Disbursement",
  "Request Original Title Deed/Deed of Assignment from Financial Institution (Vendor)",
  "Obtaining Original Title and Discharge of Charge Document (Vendor)​",
  "Obtaining Letter Confirmation cum Undertaking from Loan Solicitor (Original Title)",
  "Stamped 16N/Deed of Receipt and Reassignment​",
  "Stamped 16A",
  "Stamped 14A",
  "Forward Original Title Deed/14A/16N to Loan Solicitor for Registration at the Land Office​",
  "Forward Original Title Deed to Financier",
  "Registration Memorandum of Transfer (F14A)",
  "Registration Memorandum of Transfer (F16A)",
  "Withdrawal Caveat",
  "Served Notice of Assignment (NOA) to the Developer",
  "Notification of Final Disbursement",
  "Acknowledgement Duly Paid of Utilities Bills",
  "Vendor Handover Bundle of Keys",
  "Vacant Possession",
  "Acknowledgement Change of Name of Utilities Bills",
  "Duly Registered Title",
  "Agency Fee",
  "Referral Fee",
  "PA Execution",
  "Discharge of Charge",
  "Apply for Valuation Report from JPPH",
  "Received Valuation Report from JPPH",
  "Submit a Housing Loan Application to LPPSA",
  "Loan approved by LPPSA",
  "Received Application Consent to Transfer",
  "Received Application Consent to Charge",
  "Submission Advice to Release 1 to Financial Institution",
  "Submission Advice to Release 2 to Financial Institution",
  "Pending Duly Executed Loan Documents from Financial Institution",
  "Registration of Form 16F",
  "Forward Form 16F to the High Court",
  "Revocation of Documents at the High Court",
  "Forward Notification of Disbursement to SPA Solicitor",
  "Forward Acting First Letter to SPA Solicitor",
  "Forward Acting Final Letter to Loan Solicitor",
  "Received Financier's Letter of Undertaking from Loan Solicitor",
  "Received Order for Sale from the High Court",
  "Received Borang E/Borang F/Borang T from Pejabat Pesaka",
  "Application of Borang E/Borang F/Borang T from Pejabat Pesaka",
  "Received Letter Administration from the High Court",
  "Cancel",
  "Others",
  "Completed",
  // "Archived",
];

const fileTypeLabelsArray = [
  "Litigation",
  "Refinance",
  "Auction",
  "SPA Only",
  "SPA with LPPSA",
  "SPA with Bank Loan",
  "LPPSA loan documentation only",
  "PIBB loan documentation only",
  "BIMB loan documentation only",
  "CIMB loan documentation only",
  "Miscellaneous - Tenancy Agreement",
  "Miscellaneous - Discharge of Charge",
  "Miscellaneous - MOT (Memorandum of Transfer)",
  "Miscellaneous - Hibah (Islamic Gift)",
  "Miscellaneous - Perfection",
  "Miscellaneous - Other cases",
  "Contract Agreement",
  "Other general cases",
];

const billTypeLabelsArray = [
  "16A (Memorandum of Charge)",
  "14A (Memorandum of Transfer)",
  "16N (Discharge of Charge)",
  "SPA",
  "Loan",
  "Dev (MOT)",
  "Dev (MOC)",
  "TA",
  "AUC",
  "CA",
  "Perfection of Charge (POC)",
  "Perfection of Transfer (POT)",
  "Others",
  "Miscellaneous",
];

const clientTypeLabelsArray = [
  "Cash Vendor",
  "Cash Purchaser",
  "Cash Vendor Purchaser",
  "Bank Vendor",
  "Bank Purchaser",
  "Bank Vendor Purchaser",
  "Vendor Purchaser Loan",
  "Purchaser Loan",
  "Loan Only",
  "Tenancy",
  "Perfection of Charge",
  "Perfection of Transfer",
  "Others",
];

const clientCategoryLabelsArray = [
  "Vendor",
  "Purchaser",
  "Both (Vendor & Purchaser)",
  "Developer",
  "Corporate",
  "Contractor",
  "Others",
];

const leaveTypeLabelsArray = [
  "Annual Leave",
  "Medical Leave",
  "Hospitalization Leave",
  "Maternity Leave",
  "Unpaid Leave",
  "Compassionate Leave",
  "Marriage Leave",
];

const leaveStatusLabelsArray = ["Pending", "Approved", "Rejected"];

const claimTypeLabelsArray = [
  "Normal OT",
  "Weekend OT",
  "Attend Client",
  "Medical",
  "Travel",
  "Commission",
];

const claimStatusLabelsArray = ["Pending", "Approved", "Rejected"];

const departmentTypeLabelsArray = ["Conveyancing", "Litigation"];

const citizenshipTypeLabelsArray = ["Malaysian", "Non-Malaysian"];

const userTaxCategoryLabelsArray = [
  "Single",
  "Spouse not working, No child",
  "Spouse not working, 1 child",
  "Spouse not working, 2 children",
  "Spouse not working, 3 children",
  "Spouse not working, 4 children",
  "Spouse not working, 5 children",
  "Spouse not working, 6 children",
  "Spouse not working, 7 children",
  "Spouse not working, 8 children",
  "Spouse not working, 9 children",
  "Spouse not working, 10 children",
  "Spouse working, No child",
  "Spouse working, 1 child",
  "Spouse working, 2 children",
  "Spouse working, 3 children",
  "Spouse working, 4 children",
  "Spouse working, 5 children",
  "Spouse working, 6 children",
  "Spouse working, 7 children",
  "Spouse working, 8 children",
  "Spouse working, 9 children",
  "Spouse working, 10 children",
];

// Add this utility function to create label mappings
const createLabelMapping = (types: string[], labels: string[]) => {
  return types.reduce(
    (acc, type, index) => {
      acc[type] = labels[index];
      return acc;
    },
    {} as Record<string, string>
  );
};

// Create the label mappings
export const roleLabels = createLabelMapping(role, roleLabelsArray);

export const fileStatusLabels = createLabelMapping(
  fileStatus,
  fileStatusLabelsArray
);

export const clientTypeLabels = createLabelMapping(
  fileClientType,
  clientTypeLabelsArray
);

export const clientCategoryLabels = createLabelMapping(
  fileClientCategory,
  clientCategoryLabelsArray
);

export const fileTypeLabels = createLabelMapping(fileType, fileTypeLabelsArray);

export const billTypeLabels = createLabelMapping(
  fileBillType,
  billTypeLabelsArray
);

export const leaveTypeLabels = createLabelMapping(
  leaveType,
  leaveTypeLabelsArray
);

export const leaveStatusLabels = createLabelMapping(
  leaveStatus,
  leaveStatusLabelsArray
);

export const claimTypeLabels = createLabelMapping(
  claimType,
  claimTypeLabelsArray
);

export const claimStatusLabels = createLabelMapping(
  claimStatus,
  claimStatusLabelsArray
);

export const departmentTypeLabels = createLabelMapping(
  departmentType,
  departmentTypeLabelsArray
);

export const citizenshipTypeLabels = createLabelMapping(
  citizenshipType,
  citizenshipTypeLabelsArray
);

export const userTaxCategoryLabels = createLabelMapping(
  userTaxCategory,
  userTaxCategoryLabelsArray
);
